import { useTripsContext } from '../hooks/useTripsContext'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import {useAuthContext} from '../hooks/useAuthContext'
import { Link } from "react-router-dom"

const TripDetails = ({trip}) => {
    const { dispatch } = useTripsContext()
    const { user } = useAuthContext()

    const handleClick = async (e) => {
        e.preventDefault()
        e.stopPropagation() //prevents button click event to trigger card click event (from Link). Prevents upward propogation past button element.
        if (!user) {
            return
        }
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trip/` + trip._id, {
            method: 'DELETE',
            credentials: 'include'
        })
        const json = await response.json() //response.json in a delete request is the document that was just deleted
        
        if (response.ok) {
            dispatch({type: 'DELETE_TRIP', payload: json})
        }
    
    }   

    return (
        <Link to={`/trip/${trip._id}`} className="trip-details-link">
            <div className="trip-details">
                <h4>{trip.trip_name}</h4>
                <p><strong>Start: </strong>{trip.trip_start_date}</p>
                <p><strong>End: </strong>{trip.trip_end_date}</p>
                <p>created {formatDistanceToNow(new Date(trip.createdAt), {addSuffix: true})}</p>
                <span className="material-symbols-outlined" onClick={(e) => {handleClick(e)}}>delete</span>
            </div>
        </Link>
    )
}

export default TripDetails